export default __webpack_public_path__ + "static/media/sa2.212874c5.jpeg";